import script from "./HistoryMateni.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryMateni.vue?vue&type=script&setup=true&lang=js"

import "./HistoryMateni.vue?vue&type=style&index=0&id=7fd3edc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd3edc7"]])

export default __exports__